export enum ChatItemType {
	Message = 0, Notice, Information
}

export enum ChatItemStyle {
	Success = 0, Warning, Danger
}

export class ChatItemModel {

	id?: string;
	title?: string;
	extra?: string;
	dateDelimiter?: boolean
	icon?: string
	style?: ChatItemStyle;

	constructor(
		public username?: string,
		public message?: string,
		public createdAt?: Date,
		public fromClient?: boolean,
		public itemType?: ChatItemType
	) { }
}